import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=0f27c4be&"
import script from "./Faqs.vue?vue&type=script&lang=ts&"
export * from "./Faqs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports